import { create } from 'zustand'
interface MapNavState {
  activeMapSettingsTab: string
  openSearch: boolean
  openTable: boolean
  infoGraphicOpen: boolean
  openMapFeatureInfo: boolean
  mapAttributionText: string
  drawerOpen: boolean
  activeLayer: string | null
  navHistory: string[]
  sideBar: string | null
  currentProperty: object | null
  openMenu: boolean
  setOpenDrawer: (open: boolean) => void
  setActiveLayer: (layer: string) => void
  addToNavHistory: (path: string) => void
  setMapAttributionText: (text: string) => void
  setSideBar: (text: string) => void
  setOpenTable: (open: boolean) => void
  setOpenSearch: (open: boolean) => void
  setOpenMapFeatureInfo: (open: boolean) => void
  setCurrentProperty: (property: object) => void
  setActiveMapSettingsTab: (tab: string) => void
  setOpenInfoGraphic: (open: boolean) => void
  setOpenMenu: (open: boolean) => void
}

export const useMapNavStore = create<MapNavState>((set) => ({
  openTable: false,
  openSearch: false,
  infoGraphicOpen: false,
  openMapFeatureInfo: false,
  mapAttributionText: '',
  drawerOpen: false,
  activeLayer: null,
  openMenu: false,
  activeMapSettingsTab: 'general',
  sideBar: '',
  navHistory: [],
  currentProperty: null,
  // Toggle the drawer state
  setOpenDrawer: (open: boolean) => set(() => ({ drawerOpen: open })),

  // Set the active map layer
  setActiveLayer: (layer) => set(() => ({ activeLayer: layer })),

  // Add a new path to the navigation history
  addToNavHistory: (path) =>
    set((state) => ({
      navHistory: [...state.navHistory, path]
    })),

  setMapAttributionText: (text) => set(() => ({ mapAttributionText: text })),
  setSideBar: (text) => set(() => ({ sideBar: text })),
  setOpenTable: (open: boolean) => set(() => ({ openTable: open })),
  setOpenSearch: (open: boolean) => set(() => ({ openSearch: open })),
  setOpenMapFeatureInfo: (open: boolean) =>
    set(() => ({ openMapFeatureInfo: open })),
  setCurrentProperty: (property) => set(() => ({ currentProperty: property })),
  setActiveMapSettingsTab: (tab) => set(() => ({ activeMapSettingsTab: tab })),
  setOpenInfoGraphic: (open: boolean) => set(() => ({ infoGraphicOpen: open })),
  setOpenMenu: (open: boolean) => set(() => ({ openMenu: open }))
}))
